import { NavLink } from 'react-router-dom';
import { Home, UserPlus, FileText, Users, CreditCard } from 'lucide-react';
import { useAuth } from '../helpers/useAuth';

const Sidebar = () => {
  const { isLoggedIn, memberType } = useAuth();
  const isConsultancy = memberType === 'Consultancy';

  // Don't render sidebar if not logged in
  if (!isLoggedIn) {
    return null;
  }

  return (
<div className="w-64 bg-[#193864] text-white flex flex-col h-full shadow-xl">
      <div className="p-6 border-b border-blue-700">
        <h1 className="text-lg font-bold">Sanjivani Admission CRM</h1>
        <p className="text-blue-200 text-sm mt-1">Management System</p>
      </div>

      <nav className="flex-1 p-4 overflow-y-auto">
        <ul className="space-y-1">
          <li>
            <NavLink
              to="/"
              end
              className={({ isActive }) =>
                `flex items-center gap-3 p-3 rounded-lg transition-all ${
                  isActive 
                    ? 'bg-blue-700 shadow-md' 
                    : 'hover:bg-blue-800 hover:shadow-sm'
                }`
              }
            >
              <Home size={20} />
              <span className="font-medium">Dashboard</span>
            </NavLink>
          </li>
    {isConsultancy && (
      <>
          <li>
            <NavLink
              to="/student-registration"
              className={({ isActive }) =>
                `flex items-center gap-3 p-3 rounded-lg transition-all ${
                  isActive 
                    ? 'bg-blue-700 shadow-md' 
                    : 'hover:bg-blue-800 hover:shadow-sm'
                }`
              }
            >
              <UserPlus size={20} />
              <span className="font-medium">Student Registration</span>
            </NavLink>
          </li>
</>)}
          <li>
            <NavLink
              to="/student-report"
              className={({ isActive }) =>
                `flex items-center gap-3 p-3 rounded-lg transition-all ${
                  isActive 
                    ? 'bg-blue-700 shadow-md' 
                    : 'hover:bg-blue-800 hover:shadow-sm'
                }`
              }
            >
              <CreditCard size={20} />
              <span className="font-medium">Student Reports</span>
            </NavLink>
          </li>


          {/* Only show these for admin users */}
          {!isConsultancy && (
            <>
              <div className="pt-4 mt-4 border-t border-blue-700">
                <p className="text-xs font-semibold text-blue-300 uppercase tracking-wider px-3 mb-2">
                  Admin Controls
                </p>
                
                <li>
                  <NavLink
                    to="/create-consultant"
                    className={({ isActive }) =>
                      `flex items-center gap-3 p-3 rounded-lg transition-all ${
                        isActive 
                          ? 'bg-blue-700 shadow-md' 
                          : 'hover:bg-blue-800 hover:shadow-sm'
                      }`
                    }
                  >
                    <UserPlus size={20} />
                    <span className="font-medium">Create Consultant</span>
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to="/consultant-report"
                    className={({ isActive }) =>
                      `flex items-center gap-3 p-3 rounded-lg transition-all ${
                        isActive 
                          ? 'bg-blue-700 shadow-md' 
                          : 'hover:bg-blue-800 hover:shadow-sm'
                      }`
                    }
                  >
                    <FileText size={20} />
                    <span className="font-medium">Consultant Report</span>
                  </NavLink>
                </li>
              </div>
            </>
          )}
        </ul>
      </nav>

      <div className="p-4 border-t border-blue-700 text-center">
        <p className="text-blue-200 text-sm">
          {isConsultancy ? 'Consultant Portal' : 'Admin Portal'}
        </p>
      </div>
    </div>
  );
};

export default Sidebar;